
<div *ngIf="clientID && agentSS">

    <div>
        <div class="float-left standOutText3" *ngIf="(property?.associationType === 'Owned' && (filteredScenarios$ | async)?.length > 0) || (property?.associationType !== 'Owned')">
            Loan Scenarios
        </div>
        <div class="float-end">
            <a *ngIf="isPropertyless"  (click)="onAddScenario()"><fa-icon icon="plus"></fa-icon> New Scenario</a>
            <a *ngIf="!isPropertyless" (click)="onCreatePricingScenario()"><fa-icon icon="plus"></fa-icon> Create Pricing Scenario</a>
        </div>
        <div style="clear:both"></div>
    </div>
    <div>

        <div class="Vert-10"></div>

        <div *ngIf="(filteredScenarios$ | async)?.length === 0 && property?.associationType !== 'Owned'">
            There are currently no scenarios for this client. Create a new scenario to price and share loan opportunities for this client.
        </div>

        <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
            (change)="OnSelectedPricingScenarioChanged()" [(ngModel)]="selectedPricingScenario">
            <mat-radio-button class="example-radio-button" style="padding-right:15px;"
                *ngFor="let ps of filteredScenarios$ | async" [value]="ps">
                {{ps.name}}
            </mat-radio-button>
        </mat-radio-group>

        <div *ngIf="selectedPricingScenario as ps" class="border">
            <!--<div class="alert alert-warning">
                <div>{{ps.id}}</div>
                <div>IsOpportunitiesLoading$: {{lgvClientSvc.IsOpportunitiesLoading$ | async}}</div>
                <div>IsOpportunitiesReady$: {{lgvClientSvc.IsOpportunitiesReady$ | async}}</div>
            </div>-->
            <ng-container *ngIf="ps?.pricingScenarioType !== 'Automated'">
                <div class="float-left">
                    <div><a class="strongPhrase" (click)="onScenarioClick(ps.id)">{{ps.name}}</a></div>
                    <div>{{ps.notes}}&nbsp;</div>
                </div>
                <div class="float-end ellipsisMenuWrapper">
                    <button mat-button [matMenuTriggerFor]="LoanActionMenu">
                        <fa-icon style="font-size:18px;" icon="bars"></fa-icon>
                    </button>
                    <mat-menu #LoanActionMenu="matMenu">
                        <div class="ellipsisMenuContent">
                            <ng-container *ngIf="(filteredOpportunities$ | async) as opportunities">
                                <button *ngIf="opportunities.length > 0"  mat-menu-item (click)="onSendLockRequest(ps)"><fa-icon icon="lock"></fa-icon>&nbsp;&nbsp; Send Lock Request</button>
                            </ng-container>
                            <button  mat-menu-item (click)="onScenarioClick(ps.id)"><fa-icon icon="dollar-sign"></fa-icon>&nbsp;&nbsp; Price / Edit</button>
                            <button  mat-menu-item (click)="onRefreshOpportunity(ps)"><fa-icon icon="refresh"></fa-icon>&nbsp;&nbsp; Refresh Opportunity</button>
                            <button  mat-menu-item *ngIf="ps?.pricingScenarioType !== 'Automated'" (click)="onDuplicateScenario(ps)"><fa-icon icon="copy"></fa-icon>&nbsp;&nbsp; Duplicate</button>
                            <button  mat-menu-item (click)="onDeleteScenario(ps)"><fa-icon icon="trash"></fa-icon>&nbsp;&nbsp; Remove</button>
                        </div>
                    </mat-menu>
                </div>
            </ng-container>

            <ng-container *ngIf="ps?.pricingScenarioType === 'Automated'">
                <div class="float-left">
                    <div><a class="strongPhrase" >{{ps.name}}</a></div>
                </div>
                <div class="float-end ellipsisMenuWrapper">
                    <button mat-button [matMenuTriggerFor]="LoanActionMenu">
                        <fa-icon style="font-size:18px;" icon="bars"></fa-icon>
                    </button>
                    <mat-menu #LoanActionMenu="matMenu">
                        <div class="ellipsisMenuContent">
                            <button  mat-menu-item (click)="onScenarioClick(ps.id)"><fa-icon icon="dollar-sign"></fa-icon>&nbsp;&nbsp; Price</button>
                            <button  mat-menu-item (click)="onRefreshOpportunity(ps)"><fa-icon icon="refresh"></fa-icon>&nbsp;&nbsp; Refresh Opportunity</button>
                        </div>
                    </mat-menu>
                </div>
            </ng-container>
            
            <div style="clear:both"></div>

            <div class="Vert-15"></div>
            <div class="row">
                <div class="col-12 col-lg-3">
                    <b> {{ps?.pricingScenarioType !== 'Automated' ? 'Purchase Type' : 'Refi Type'}}</b>: {{ps.request.loanInformation.loanPurpose}}
                </div>
                <div class="col-12 col-lg-3">
                    <b>Loan Amount</b>: ${{ps.request.loanInformation.baseLoanAmount | number : '1.0-0'}}
                </div>
                <div class="col-12 col-lg-3">
                    <b>Last Update</b>: {{ps.updatedTimestamp | date: 'short'}}
                </div>
            </div>

            <div class="Vert-30"></div>
            <div class="section-header">{{ ps?.pricingScenarioType !== 'Automated' ? 'Current Opportunities' : 'Refinance Opportunities'}}</div>
            <div class="Vert-15"></div>
            <div class="table-responsive">
                <table class="table table-striped" *ngIf="(filteredOpportunities$ | async) as opportunities">
                    <tr>
                        <th>Type</th>
                        <th>Product</th>
                        <th>Est. Fees</th>
                        <th>Payment</th>
                        <th>Rate</th>
                        <th>APR</th>
                        <th>Term</th>
                    </tr>
                    <tr *ngFor="let o of opportunities">
                        <td>{{o.opportunityType?.name}}</td>
                        <td>{{o.opportunityInfo.productName}}</td>
                        <td>${{o.opportunityInfo.closingCost | number : '1.0-0' | null}}</td>
                        <td>${{o.opportunityInfo.marketPayment | number : '1.0-0' | null}}</td>
                        <td>{{o.opportunityInfo.matchedRate | number : '1.3-3'}}%</td>
                        <td>{{o.opportunityInfo.matchedApr | number : '1.3-3'}}%</td>
                        <td>{{o.opportunityInfo.loanTermMonths}}</td>
                    </tr>
                </table>
            </div>
            
            <lgv-loading-indicator [CSSClass]="'Small'" *ngIf="lgvClientSvc.IsOpportunitiesLoading$ | async"></lgv-loading-indicator>

        </div>

    </div>


</div>
